import React, {
  useRef,
  useMemo,
  useState,
  useEffect,
  useLayoutEffect,
} from "react";
import { useFormContext, useWatch } from "react-hook-form";

import { CrossIcon } from "../../../../assets";
import { EMPTY_STRING } from "../../../../constants";
import SurveyFormField from "../../../../shared/components/surveyFormField/SurveyFormField";

const CitizenshipPreference = ({ allCountries }) => {
  const scrollPosition = useRef(0);
  const countryListRef = useRef(null);
  const [searchValue, setSearchValue] = useState(EMPTY_STRING);

  const {
    setValue,
    formState: { errors },
  } = useFormContext();

  const selectedCountryId = useWatch({ name: "interestedCitizenshipId" });

  // Restore scroll position after DOM updates
  useLayoutEffect(() => {
    if (countryListRef.current) {
      countryListRef.current.scrollTop = scrollPosition.current;
    }
  });

  // Filter and prioritize selected country
  const filteredCountries = useMemo(() => {
    if (countryListRef.current) {
      scrollPosition.current = countryListRef.current.scrollTop;
    }

    const search = searchValue?.trim()?.toLowerCase();
    const list = !search
      ? allCountries
      : allCountries?.filter((country) =>
          country.name.toLowerCase().includes(search)
        );

    const selected = list.find((country) => country.id === selectedCountryId);
    const others = list.filter((country) => country.id !== selectedCountryId);

    return selected ? [selected, ...others] : list;
  }, [searchValue, allCountries, selectedCountryId]);

  // Reset search field on mount
  useEffect(() => {
    setValue("searchField", EMPTY_STRING);
  }, []);

  return (
    <div className="form-fields-search">
      <div className="question-heading">
        Interested in foreign citizenship? If yes, which country tops your list?{" "}
        <span>(Select one)</span>
        {errors.interestedCitizenshipId && (
          <div className="error">{errors.interestedCitizenshipId.message}</div>
        )}
      </div>
      <div className="mt-5 mb-2 pe-2-rem">
        <SurveyFormField
          name="searchField"
          placeHolder="Search here"
          textValue={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          endAdornment={
            searchValue ? (
              <div className="position-absolute send-icon-adornment pointer">
                <img
                  alt="Clear"
                  src={CrossIcon}
                  className="white-filter"
                  onClick={() => {
                    setValue("searchField", EMPTY_STRING);
                    setSearchValue(EMPTY_STRING);
                  }}
                />
              </div>
            ) : null
          }
        />
      </div>
      <div
        className="form-fields form-fields-dropdown mt-0"
        ref={countryListRef}
      >
        {filteredCountries?.length > 0 ? (
          filteredCountries.map((country) => (
            <SurveyFormField
              name="interestedCitizenshipId"
              key={country.id}
              variant="radio"
              label={country.name}
              value={country.id}
              endAdornment={
                <div className="position-absolute flags-adornment">
                  <img
                    src={country.flag}
                    className="country-flag"
                    alt={EMPTY_STRING}
                  />
                </div>
              }
            />
          ))
        ) : (
          <div className="text-center my-2 py-2">No data found!</div>
        )}
      </div>
    </div>
  );
};

export default CitizenshipPreference;
